import { render, staticRenderFns } from "./SpecialMenu.vue?vue&type=template&id=5e5364b7&"
import script from "./SpecialMenu.vue?vue&type=script&lang=js&"
export * from "./SpecialMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports